import { createAction, props } from '@ngrx/store';

/**
 * Clears all locales
 */
export const clearLocales = createAction('[Locale Effects] Clear');

/**
 * Fetches a specific locale file for angular
 */
export const fetchLocaleFile = createAction('[Locale Effects] Fetch Locale Files', props<{ payload: string }>());

/**
 * When the client configuration initialization fails to load the locale file.
 */
export const fetchLocaleFileOnClientConfigurationErrorAction = createAction(
	'[App Initialize] Fetch Locale Files On Client Configuration Error',
	props<{ payload: string }>()
);

/**
 * The action for when a locale file downloads completely
 */
export const fetchLocaleFileSuccess = createAction('[Locale Effects] Fetch Locale File Success');
